import { DatosAnioListDashboard } from "./DatosAnioListDashboard";
import { Content } from "@/components/ui/ContentArea";

export function EmpresaPage() {
	return (
		<Content className="p-5">
			<title>Listado de Datos Anuales</title>
			<DatosAnioListDashboard />
		</Content>
	);
}
